import { useEffect, useState, useCallback } from "react";
import { useAppInfo, useAppInfoFromUralParams } from "../../../../helpers/hooks/common-hook";
import { getAgentActions } from "../../../../services/prompt-ai";
import { isWorkflowRecord } from "../../../playbooks/model/playbook-model";

export default function useJourneyList() {
  const { appId: paramAppId } = useAppInfoFromUralParams();
  const appInfo = useAppInfo();

  // Use appId from URL params first, fallback to context
  const appId = paramAppId || appInfo?.appId;

  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchJourneys = useCallback(async () => {
    if (!appId) return;
    setLoading(true);
    setError(false);
    try {
      const settings = await getAgentActions(appId);
      if (settings.data) {
        // Playbook-authored records are edited in the Playbooks section; showing
        // them here would let the canvas overwrite their step model on save.
        setDataList(settings.data.filter(isWorkflowRecord));
      }
    } catch (e) {
      console.error("Failed to fetch journeys:", e);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [appId]);

  useEffect(() => {
    fetchJourneys();
  }, [fetchJourneys]);

  return {
    dataList,
    loading,
    error,
    refetch: fetchJourneys,
    appId,
    appInfo,
  };
}
